import {
    assign,
    nullable,
    number,
    object,
    optional,
    string,
} from "superstruct";

export const RewardsFreeProductVariantSchema = object({
    id: number(),
    title: optional(string()),
    image: optional(nullable(string())),
});

//This schema is used in v3 api endpoints
export const RewardsProductVariantSchema = assign(
    RewardsFreeProductVariantSchema,
    object({
        price: number(),
    })
);
